import React from 'react';
import counterReducer from '@pages/payroll-plus-new/reducer';
import sagas from '@pages/payroll-plus-new/sagas/index';
import { withReducer } from 'src/store/reducerLoader';
import ETypo from '@pages/DesignSystem/Typo';
import './beneficiary-details.scss';

const BeneficiaryDetails = ({ details }) => {
	return (
		<div className="invoice-bank-details-container">
		<ETypo b1 medium className="beneficiary-details" color="#00344E">
			Beneficiary Details
		</ETypo>
		{details?.map((res, index) => {
			return (
				<>
					<div className="name" key={index}>
						<ETypo b2 medium color="#484B52">
							{res?.title}
						</ETypo>
					</div>
					<div className="value" key={index}>
						<ETypo b2 light color="#484B52">
							{res?.value}
						</ETypo>
					</div>
				</>
			);
		})}
	</div>
	);
};
const ReducedScreen = withReducer('payrollPlusState', counterReducer, sagas)(BeneficiaryDetails);
export default ReducedScreen;
